import React, { useMemo } from "react";
import Table from "react-bootstrap/Table";
import Pagination from "react-bootstrap/Pagination";
import { headerStyle } from "../../../assets/css/customStyle";
import { useNavigate, useParams } from "react-router-dom";

const PayoutTable = ({ payoutData }) => {
  const param = useParams();
  const navigate = useNavigate();
  const pageSize = 25;
  const [page, setPage] = React.useState(1);

  const totalRecords = payoutData?.length || 0;
  const totalPages = Math.max(1, Math.ceil(totalRecords / pageSize));

  const pageData = useMemo(() => {
    const safePage = Math.min(Math.max(page, 1), totalPages);
    const start = (safePage - 1) * pageSize;
    const end = start + pageSize;
    return (payoutData || []).slice(start, end);
  }, [page, payoutData, totalPages]);

  /**
   * Transection list Modal Open
   * @param {*Owes User Name} cell
   * @param {*Owes User List} row
   * @returns
   */
  const openUser = (row) => {
    navigate(`/events/payout/user`, {
      state: { userid: row.user_id, eventid: param.eventid },
    });
  };

  const openOwedUser = (row) => {
    const calc = row?.calculations?.[0];
    if (!calc?.user_id) return;
    navigate(`/events/payout/user`, {
      state: { userid: calc.user_id, eventid: param.eventid },
    });
  };

  const getOwsAmount = (row) => {
    const value = row?.calculations?.[0]?.ows;
    if (value === null || value === undefined) return "";
    const num = typeof value === "number" ? value : Number(value);
    if (Number.isFinite(num)) return num.toFixed(2);
    return String(value);
  };

  const from = totalRecords === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, totalRecords);

  const maxPageCount = 5;
  const paginationItems = [];
  let startPage = Math.max(page - Math.floor(maxPageCount / 2), 1);
  let endPage = Math.min(startPage + maxPageCount - 1, totalPages);
  if (endPage - startPage < maxPageCount - 1) {
    startPage = Math.max(endPage - maxPageCount + 1, 1);
  }
  for (let p = startPage; p <= endPage; p++) {
    paginationItems.push(
      <Pagination.Item key={p} active={p === page} onClick={() => setPage(p)}>
        {p}
      </Pagination.Item>
    );
  }

  return (
    <div>
      <div className="react-event-table-class">
        <Table bordered hover responsive className="mb-0">
          <thead>
            <tr>
              <th style={{ width: "10%", ...headerStyle }}>Sr no</th>
              <th style={{ width: "30%", ...headerStyle }}>User Name</th>
              <th style={{ width: "30%", ...headerStyle }}>Owes User</th>
              <th style={{ ...headerStyle }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {pageData.length > 0 ? (
              pageData.map((row, idx) => (
                <tr key={row.user_id ?? `${row.secquenceNo ?? idx}`} className="table-bg-col">
                  <td>{row.secquenceNo ?? (from + idx)}</td>
                  <td>
                    <h6 onClick={() => openUser(row)} className="event-title-open mb-0">
                      {row.full_name}
                    </h6>
                  </td>
                  <td>
                    <h6 onClick={() => openOwedUser(row)} className="event-title-open mb-0">
                      {row?.calculations?.[0]?.full_name || ""}
                    </h6>
                  </td>
                  <td>
                    <div className="text-success">+{getOwsAmount(row)}</div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="table-bg-col">
                <td colSpan={4} className="text-center">
                  No Result Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-between mt-3 align-items-center">
        <div>
          <span>
            {totalRecords === 0
              ? "No users to display"
              : `Showing users ${from} to ${to} of ${totalRecords}`}
          </span>
        </div>
        <div>
          <Pagination className="mb-0">
            {page > 1 && <Pagination.Prev onClick={() => setPage(page - 1)} />}
            {paginationItems}
            {page < totalPages && <Pagination.Next onClick={() => setPage(page + 1)} />}
          </Pagination>
        </div>
      </div>
    </div>
  );
};

export default PayoutTable;
